// @core/api/endpoints/activity/record_decision.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RecordDecisionRequest,
  RecordDecisionResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Record a decision
 * Records a team decision linked to an entity (task, project, document). Creates an Activity with category=DECISION. Optionally links to a ChatService conversation and notifies team members.
 */
export async function RecordDecision(
  data: RecordDecisionRequest,
  options?: RequestOptions
): Promise<RecordDecisionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/decisions`;
  const requestOptions = options;
  return client.post<RecordDecisionResponse>(requestPath, data, requestOptions);
}
